<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "3rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M22.94 4.44a1.5 1.5 0 012.12 0l12.5 12.5a1.5 1.5 0 01-2.12 2.12L25.5 9.122V42.5a1.5 1.5 0 01-3 0V9.121l-9.94 9.94a1.5 1.5 0 01-2.12-2.122l12.5-12.5z"/></svg>